export default __webpack_public_path__ + "static/media/onboarding_popup.aaad31f2.jpg";